'use client'

import * as React from 'react'
import { Button } from './button'
import { Icon } from './icon'
import useTheme from '../../hooks/useTheme'

export function ThemeToggle() {
	const { setTheme, theme } = useTheme()

	return (
		<Button
			variant="ghost"
			size="icon"
			onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
		>
			<Icon name="moon" className="h-4 w-4" />
			<Icon name="sun" className="h-4 w-4" />

			<span className="sr-only">Toggle theme</span>
		</Button>
	)
}
